import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LiveMetricsSection from './components/LiveMetricsSection';
import AIAgentsSection from './components/AIAgentsSection';
import FeaturesSection from './components/FeaturesSection';
import DeveloperSection from './components/DeveloperSection';
import ArchitectureSection from './components/ArchitectureSection';
import RoadmapSection from './components/RoadmapSection';
import { useTheme } from '@/contexts/ThemeContext';

export default function Home() {
  const { isDark } = useTheme();

  return (
    <div className={`relative min-h-screen overflow-x-hidden ${isDark ? 'bg-[#050505] text-white' : 'bg-[#f5f5f5] text-[#111]'}`}>
      {/* Global background effects */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className={`absolute top-0 left-1/4 w-[600px] h-[600px] rounded-full blur-[150px] ${isDark ? 'bg-[#00ff88]/[0.02]' : 'bg-[#00ff88]/[0.04]'}`} />
        <div className={`absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full blur-[120px] ${isDark ? 'bg-[#00ff88]/[0.015]' : 'bg-[#00ff88]/[0.03]'}`} />
      </div>

      <Navbar />

      <main className="relative z-10">
        <HeroSection />
        <LiveMetricsSection />
        <AIAgentsSection />
        <FeaturesSection />
        <DeveloperSection />
        <ArchitectureSection />
        <RoadmapSection />
      </main>

      <Footer />
    </div>
  );
}